// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"194c26c6","498":"306319fe","513":"a8c2e228"}[chunkId] + ".chunk.js";
};